import Axios from "./axios";

const resource = "job-testimonials";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}